import React from 'react'

import { Link } from 'react-router-dom';


function CheckEligibilityBtn({styleClass}) {
    return (
        <>
            <div className={`${styleClass || "Check-btn"}`}>
               <a className="btn" href="/quiz">Check Eligibility</a>               
            </div>
        </>
    )
}

export default CheckEligibilityBtn
